import React, {useEffect, useState} from "react";
import "./BackupRestore.css";
import Row from "react-bootstrap/Row";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCloud} from "@fortawesome/free-solid-svg-icons";
import Restore from "./Restore";
import Backup from "./Backup";
import Upload from "./Upload";
import CloudBackupApi from "../../../lib/api/cloudBackup";
import config from "../../../config";
import {useAuth} from "../../../contexts/AuthContext";

// Parse API URL from config
const getApiConfig = () => {
    const apiUrl = config.api.palantirApi;
    const url = new URL(apiUrl);
    return {
        host: url.hostname,
        port: url.port || (url.protocol === "https:" ? "443" : "80"),
        isHttps: url.protocol === "https:"
    };
};

const defaultConfig = getApiConfig();

function BackupRestore({bond}) {
    const { getToken } = useAuth();
    const [host, setHost] = useState(defaultConfig.host);
    const [port, setPort] = useState(defaultConfig.port);
    const [isHttps, setIsHttps] = useState(defaultConfig.isHttps);
    const [backupApi, setBackupApi] = useState(null);
    const restoreApi = new CloudBackupApi(defaultConfig.host, defaultConfig.port, defaultConfig.isHttps, bond, getToken);
    const [updatedFolder, setUpdatedFolder] = useState(null);

    useEffect(() => {
        if (host && port) {
            setBackupApi(new CloudBackupApi(host, port, isHttps, bond, getToken));
        }

    }, [host, port, isHttps]);

    function onUploadDone(folder) {
        setUpdatedFolder(null);
        setTimeout(() => {
            setUpdatedFolder(folder)
        }, 10);
    }

    return (<Row>
        <Col className={"col-12 col-xl-8"}>
            <h2><FontAwesomeIcon icon={faCloud} className="me-2"/>Backup/Restore Server</h2>

            <InputGroup className="mb-3">
                <InputGroup.Text className="backupInputLabel">Host</InputGroup.Text>
                <Form.Control
                    placeholder="Enter host"
                    aria-label="Host"
                    aria-describedby="host-label"
                    value={host || ""}
                    onChange={(e) => setHost(e.target.value)}
                />
            </InputGroup>
            <InputGroup className="mb-3">
                <InputGroup.Text className="backupInputLabel">Port</InputGroup.Text>
                <Form.Control
                    placeholder="Enter port"
                    aria-label="Port"
                    aria-describedby="port-label"
                    value={port || ""}
                    onChange={(e) => setPort(e.target.value)}
                />
            </InputGroup>
            <InputGroup className="mb-3">
                <label className={"me-2"}>HTTP</label>
                <Form.Check
                    type="switch"
                    id="is-https-switch"
                    label="HTTPS"
                    checked={isHttps}
                    onChange={(e) => setIsHttps(e.target.checked)}
                />
            </InputGroup>
            <hr/>
        </Col>
        <Col className={"col-12 col-xl-4 p-2"}>
            <Backup bond={bond} backupApi={backupApi} onUploadDone={onUploadDone}/>
            <Upload bond={bond} backupApi={backupApi} restoreApi={restoreApi} onUploadDone={onUploadDone}/>
        </Col>
        <Restore bond={bond} backupApi={backupApi} restoreApi={restoreApi} updatedFolder={updatedFolder}/>

    </Row>);
}

export default BackupRestore;
